"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var COLOUR_MAP = {
  darkMode: {
    icon: "michael",
    background: "black"
  },
  default: {
    icon: "aqua",
    background: "white"
  }
};

function getDarkModeImageProps() {
  var _ref = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      darkMode = _ref.darkMode;

  return darkMode ? COLOUR_MAP.darkMode : COLOUR_MAP["default"];
}

var _default = getDarkModeImageProps;
exports["default"] = _default;